/* eslint-disable no-nested-ternary */
import { useEffect, useState, lazy } from 'react';
import styled from 'styled-components';
import { Row, Col, Tooltip, Popover } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import ProfileSharePopup from 'Components/common/components/ProfileSharePopup';
import {
  ArcheType,
  IBehaviour, ICommunicationTips, IMotivations,
  IQualities, PersonCard, SocialLink, SocialLinks,
} from 'Types/PersonTypes';
import {
  isDuke,
  isFreeUser,
  isGuest,
  isGuestfromEmail,
  IsMobile,
  IsTablet,
} from 'Utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { actions as personActions } from 'Slice/ProfileShareSlice';
import { BranchIORequest } from 'Types/RequestBodies';
import classNames from 'classnames';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import {
  selectActivetype, selectData, selectHighlight,
  selectIsHighlighted,
  selectIsScroll,
} from 'Selector/CertificationSelector';
import { selectPersonDossierAllowed, selectUnderstandExplored } from 'Selector/PersonProfileSelector';
import UnderstandIcon from '../../common/assets/svgIcons/UnderstandIcon';
import InterpretIcon from '../../common/assets/svgIcons/InterpretIcon';
import ActIcon from '../../common/assets/svgIcons/ActIcon.tsx';
import DownloadIcon from 'Components/common/assets/svgIcons/DownloadIcon';
import TwitterIcon from '../../common/assets/svgIcons/TwitterIcon';
import LinkedInIcon from '../../common/assets/svgIcons/LinkedInIcon';
import ShareIcon from '../../common/assets/svgIcons/ShareIcon';
import GlobalButton from '../../common/components/GlobalButton';
import {
  primaryHeadingColor, primaryColor, wLight, wMedium,
  wELight, secondaryFont, primaryFont, wMBold, wBold,
  maxWidth, retina, maxTablet, maxMobile, smMobile, SecondaryColor,
} from '../../../Utils/utilsStyle';
import Qualities from './Qualities';
import CommunicationTips from './CommunicationTips';
import DrawerPersonPersonality from './DrawerPersonPersonality';
import PromotionIcon from '../../common/assets/svgIcons/Promotionicon';
import { selectShowUnderstandBlip } from '../../../Selector/UISelector';
import BranchIo from 'deeplinking/BranchIo';


type Props = {
  behaviour?: IBehaviour;
  qualities?: IQualities;
  communicationTips?: ICommunicationTips,
  motivations?: IMotivations,
  personaColor?: string;
  socialLinks?: SocialLinks;
  personality?: string;
  onDownloadProfileClick?: () => void;
  personDownloadLoading?: boolean;
  personInfo?: PersonCard;
  archeType?: ArcheType;
  isGuestUser?: boolean;
  handleGilroyStrategyClick?: (type: string) => void;
} & typeof defaultProps;

const defaultProps = {
  behaviour: { description: 'Adam tends to be pragmatic, logical, and firm when making decisions but very skeptical when emotions are involved. ' },
  qualities: { dataList: [] },
  communicationTips: { dataList: [] },
  motivations: { description: '', dataList: [] },
  personaColor: '#E79540',
  socialLinks: { data: [] } as SocialLinks,
  personality: 'Id',
  onDownloadProfileClick: () => { },
  personDownloadLoading: false,
  personInfo: {},
  archeType: {},
  isGuestUser: false,
};

const Wrapper = styled.div<{ color: string }>`
 padding: 0 45px;
 @media all and (max-width: ${maxWidth}) , ${retina} {
   padding: 0 25px;
 }
 @media all and (max-width: ${maxTablet}) {
   padding: 0 15px;
 }
 .chatbot-notes-div {
   .chatbot-v2-global-btn {}
 }
 .wheel-main-layer {
  @media all and (max-width: ${maxTablet}) {
    align-items: center;
    margin-top: 50px;
  }
 }
 .wheel-outer-layer {
    box-shadow: 0px 0px 5px ${(props) => props.color};
    border-radius: 50%;
    width: 320px;
    min-width: 320px;
    min-height: 320px;
    margin: 0 auto;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      width: 280px;
      min-width: 280px;
      min-height: 280px;
    }
    @media all and (max-width: ${maxTablet}) {
      width: 180px;
      min-width: 180px;
      min-height: 180px;
    }
    &.upper-area-wheel {
      @media all and (max-width: ${maxMobile}) {
        width: 320px;
        min-width: 320px;
        min-height: 320px;
        margin-top: 40px;
      }
      @media all and (max-width: ${smMobile}) {
        width: 250px;
        min-width: 250px;
        min-height: 250px;
      }
    }
  }
 .left-action-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-left: 5px;
  .ant-tooltip-inner {
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    color: ${primaryHeadingColor};
  }
  .understand-btn-blip {
      position: absolute;
      cursor: pointer;
      top: 17px;
      left: 35px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        top: 8px;
        left: 15px;
        svg{
          width: 30px;
          height: 30px;
        }
      }
      @media all and (max-width: ${maxTablet}) {
        left: 8px;
        svg{
          width: 28px;
          height: 28px;
        }
      }
      @media all and (max-width: ${maxMobile}) {
        left: -3px;
        svg{
          width: 26px;
          height: 28px;
        }
      }
  }
  .guided-selling-buttons-wrapper {
    gap: 10px;
  }
  }
  .understand-btn, .interpret-btn, .act-btn {
    svg {
      margin-right: 4px;
    }
  }
  .understand-btn, .interpret-btn, .act-btn {
    &:hover {
      background-color: ${SecondaryColor};
      color: #fff;
      outline: none;
      svg {
        path {
          fill: #fff;
        }
      }
    }
  }
 .social-placeholders {
  display: flex;
  justify-content: flex-end;
  margin-top: 0px;
  @media all and (max-width: ${maxMobile}) {
    margin-top: 0px;
    width: auto;
    justify-content: flex-start;
  }
  .share-button {
    @media all and (max-width: ${maxMobile}) {
      margin-right: 12px;
    }
  }
  .download-person-profile, .share-button {
    .regenerate-icon-svg {
      width: 16px;
      height: 17px;
      margin-bottom: 2px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 14px;
        height: 14px;
        margin-bottom: 2px;
      }
    }
    svg {
      margin-right: 8px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-right: 4px;
        width: 16px;
        min-width: 16px;
        height: 16px;
      }
    }
    &:hover {
      background-color: ${SecondaryColor};
      color: #fff;
      outline: none;
      svg {
        path {
          fill: #fff;
        }
      }
    }
  }
  .social-icons-wrap {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    height: 28px;
    .scc-place {
      margin-right: 0px;
      height: unset;
      &.twit-icon {
        margin-right: 8px;
      }
    }
    &.guestSocial{
    .scc-place:nth-child(2) svg {
      width:25px;
    }
   }
  }
 }
 .personality-wheel {
  &.dukeDisk {
    border-radius: inherit;
  }
  height: 100%;
  width: 100%;
  padding: 15px;
 }
 h3{
  color: ${primaryHeadingColor};
  font-weight:${wMedium};
  font-family:${primaryFont};
  font-size:20px;
  margin:0;
 }
 h4{
  color: ${primaryHeadingColor};
  font-weight:${wMedium};
  font-family:${primaryFont};
  font-size:14px;
  margin:0;
   span{
    font-size: 10px;
    font-weight:${wELight} ;
    font-family:${primaryFont};
  }
 }
 .finincal-detail{
    color: ${primaryColor};
    font-weight:${wLight};
    font-family:${secondaryFont};
    font-size:14px;
    padding:4px 0;
 }
 .person-description{
   div.ant-typography, .ant-typography p{
    margin:0px;
    color:#7E7E7E;
    font-weight:${wLight};
    font-family:${primaryFont};
    font-size:16px;
    white-space: pre-wrap;
     .ant-typography-expand{
        color:${primaryColor};
      }
   }
 }
 .people-overlap-wrapper{
   position:relative;
   margin:10px 0;
   z-index:0 ;
   > div{
     position: absolute;
     top:0;
     left:0;

     &:nth-child(1){
      z-index: 5;
      position: relative; ;
     }
     &:nth-child(2){
       left:60px;
       z-index:4;
     }
     &:nth-child(3){
       left:120px;
       z-index:3;
     }
     &:nth-child(4){
       left:180px;
       z-index:2;
     }
     &:nth-child(5){
       left:240px;
       z-index:1;
     }
   }
 }
 .description-row{
   margin-top:30px;
   margin-bottom:16px;
   @media all and (max-width: ${maxWidth}) , ${retina} {
    margin-top: 20px;
    margin-bottom: 10px;
   }
   & p {
    color: ${primaryHeadingColor};
    font-weight: ${wMBold};
    font-family: ${secondaryFont};
    font-size: 20px;
    letter-spacing: -0.63px;
    line-height: 26px;
    margin-bottom: 5px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 16px;
       line-height: 20px;
    }
   }
 }
 .financial-card{
    margin-bottom: 16px;
  }
  .social-icon{
    display: inline-block;
    svg {
      vertical-align: text-top;
    }
  }
  .btn-chatGpt-drawer {
    margin-right: 12px;
  }
  .btn-notes-drawer {
    svg {
      margin-right: 8px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-right: 4px;
      }
    }
  }
`;

const MoreOnPersonality = styled.div<{ color: string }>`
  .personality-div {
    margin-top: 5px;
    border-radius: 8px;
    padding: 0px 15px;
    border: 1px solid ${(props) => props.color};
    /* make it display flex and align center */
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: fit-content;
    .personality-text {
      /* color: ${(props) => props.color}; */
      color: #fff;
      font-family: ${secondaryFont};
      font-weight: ${wBold};
      font-size: 16px;
      letter-spacing: -0.35px;
      line-height: 36px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 12px;
        line-height: 25px;
      }
    }
    & svg {
      margin-left: 10px;
      width: 20px;
      margin-top: 2px;
      height: 16px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 12px;
        height: 10px;
        margin-left: 5px;
      }
    }
  }
  &:hover {
    cursor: pointer;
  }
`;

const PersonDetails = function PersonDetails(props: Props) {
  const dispatch = useDispatch();
  const [runFunction, setRunFunction] = useState(true);
  const isTab = IsTablet();
  const dossierAllowed = useSelector(selectPersonDossierAllowed);
  const localBlipState = useSelector(selectShowUnderstandBlip);
  const isUnderstandExplored = useSelector(selectUnderstandExplored);
  const {
    personInfo,
    behaviour,
    qualities,
    communicationTips,
    personaColor,
    socialLinks,
    onDownloadProfileClick,
    personDownloadLoading,
    isGuestUser,
    handleGilroyStrategyClick,
  } = props;
  const showBlipIcon = isUnderstandExplored === 1 ? !!localBlipState : !!isUnderstandExplored;
  const guestUser = isGuest() || isGuestfromEmail();

  const data = useSelector(selectData);
  const isMob = IsMobile();
  const isDukeBoolean: boolean = isDuke();
  const { archeType } = personInfo || {};

  const onShareProfile = () => {
    if (runFunction) {
      // <BranchIo />
      const branchprofileData: BranchIORequest = {
        data: {
          $og_title: personInfo.personName,
          $og_description: behaviour.description,
          $canonical_identifier: personInfo.personId,
          $canonical_url: window.location.href,
          title: personInfo.personName,
          id: personInfo.personId,
          entity: 'person_share',
        },
      };
      dispatch(personActions.getProfileShare(branchprofileData));
    }
    setRunFunction(false);
    dispatch(certificationActions.certificationAction({
      type: 'person_share_header',
      source: 'person',
      data,
    }));
  };

  const isScroll = useSelector(selectIsScroll);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);
  const [activeTooltip, setActiveTooltip] = useState<
    'understand' | 'interpret' | 'act' | null
  >(null);

  const handleStrategyButtonClick = (title: string) => {
    handleGilroyStrategyClick?.(title);
  };

  useEffect(() => {
    if (!isHighlighted && !isScroll && (currentType === 'person_download_header' || currentType === 'person_share_header'
      || currentType === 'person_note_write')) {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  const Content = () => (
    <div className="understand-btn-popover-content">
      Explore New Feature by clicking on it
    </div>
  );

  return (
    <Wrapper color={personaColor}>
      {isMob ? (
        archeType && archeType?.image
        && (
          <div className="wheel-outer-layer upper-area-wheel">
            <img src={archeType?.image} alt="personality-disc" className={classNames('img-fluid personality-wheel', { dukeDisk: isDukeBoolean })} />
          </div>
        )
      ) : null}
      <div className="d-flex justify-content-between social-and-action-here wrap-slider hidden-scroll">
        <div className="actions left-action-buttons">
          {!isGuestUser && !isFreeUser() ? (
            <div className="guided-selling-buttons-wrapper d-flex align-items-center">
              <Tooltip
                trigger="hover"
                placement="bottomLeft"
                getPopupContainer={(e: HTMLElement) => e}
                className="guided-selling-button-tooltip"
                color="#fff"
                title={'Explore personality traits, motivations, and behavior patterns'}
                arrow={false}
                styles={{
                  root: {
                    maxWidth: '100%',
                    width: 'fit-content',
                  },
                }}
                open={activeTooltip === 'understand'}
                onOpenChange={(visible) => {
                  setActiveTooltip(visible ? 'understand' : null);
                }}
              >
                <div>
                  <GlobalButton
                    title="Understand"
                    textColor={SecondaryColor}
                    outlineColor={SecondaryColor}
                    PaddingSm="5px 10px"
                    innerSpace="11px 16px"
                    heightSm="30px"
                    RightSeparator={false}
                    buttonClassName="understand-btn"
                    IconLeft={isTab ? <span /> : <UnderstandIcon color={SecondaryColor} />}
                    onButtonClick={() => {
                      setActiveTooltip(null);
                      handleStrategyButtonClick('Understand');
                    }}
                  />
                  <Popover
                    placement="bottom"
                    content={<Content />}
                    getPopupContainer={() => document.body}

                    arrow={false}
                  >
                    <span className='understand-btn-blip'>{!!showBlipIcon && <PromotionIcon />}</span>
                  </Popover>
                </div>
              </Tooltip>
              <Tooltip
                trigger="hover"
                placement="bottomLeft"
                getPopupContainer={(e: HTMLElement) => e}
                className="guided-selling-button-tooltip"
                color="#fff"
                title={'Uncover decision-making styles, priorities, and pain points'}
                arrow={false}
                styles={{
                  root: {
                    maxWidth: '100%',
                    width: 'fit-content',
                  },
                }}
                open={activeTooltip === 'interpret'}
                onOpenChange={(visible) => {
                  setActiveTooltip(visible ? 'interpret' : null);
                }}
              >
                <div>
                  <GlobalButton
                    title="Interpret"
                    textColor={SecondaryColor}
                    outlineColor={SecondaryColor}
                    PaddingSm="5px 10px"
                    innerSpace="11px 16px"
                    heightSm="30px"
                    RightSeparator={false}
                    IconLeft={isTab ? <span /> : <InterpretIcon color={SecondaryColor} />}
                    buttonClassName="interpret-btn"
                    onButtonClick={() => {
                      setActiveTooltip(null);
                      handleStrategyButtonClick('Interpret');
                    }}
                  />
                </div>
              </Tooltip>
              <Tooltip
                trigger="hover"
                placement="bottomLeft"
                getPopupContainer={(e: HTMLElement) => e}
                className="guided-selling-button-tooltip"
                color="#fff"
                title={'Apply engagement strategies and communication recommendations'}
                arrow={false}
                styles={{
                  root: {
                    maxWidth: '100%',
                    width: 'fit-content',
                  },
                }}
                open={activeTooltip === 'act'}
                onOpenChange={(visible) => {
                  setActiveTooltip(visible ? 'act' : null);
                }}
              >
                <div>
                  <GlobalButton
                    title="Act"
                    textColor={SecondaryColor}
                    outlineColor={SecondaryColor}
                    PaddingSm="5px 10px"
                    innerSpace="11px 16px"
                    heightSm="30px"
                    RightSeparator={false}
                    IconLeft={isTab ? <span /> : <ActIcon color={SecondaryColor} />}
                    buttonClassName="act-btn"
                    onButtonClick={() => {
                      setActiveTooltip(null);
                      handleStrategyButtonClick('Act');
                    }}
                  />
                </div>
              </Tooltip>
            </div>
          ) : null}
        </div>
        <div className="actions social-placeholders">
          {!guestUser && (
            <>
              {dossierAllowed
                ? (
                  <GlobalButton
                    title="Download"
                    textColor={SecondaryColor}
                    outlineColor={SecondaryColor}
                    RightSpace="12px"
                    LeftSpace="12px"
                    PaddingSm="5px 10px"
                    innerSpace="11px 16px"
                    heightSm="30px"
                    RightSeparator={false}
                    disabled={personDownloadLoading}
                    IconLeft={(isTab || personDownloadLoading)
                      ? <span /> : <DownloadIcon color={SecondaryColor} />}
                    loading={personDownloadLoading}
                    onButtonClick={onDownloadProfileClick}
                    buttonClassName={classNames(
                      'download-person-profile',
                      { highlightedComponent: isHighlight && currentType === 'person_download_header' },
                      { downloadProfileBtn: isHighlight && currentType === 'person_download_header' },
                    )}
                  />
                )
                : null}
              <ProfileSharePopup subject={personInfo.personName} isPerson>
                <GlobalButton
                  title="Share"
                  textColor={SecondaryColor}
                  outlineColor={SecondaryColor}
                  PaddingSm="5px 10px"
                  innerSpace="11px 16px"
                  heightSm="30px"
                  IconLeft={isTab ? <span /> : <ShareIcon color={SecondaryColor} />}
                  buttonClassName={classNames(
                    'share-button index-one',
                    { highlightedComponent: isHighlight && currentType === 'person_share_header' },
                  )}
                  rightSeparatorClassName="right-separator-class"
                  onButtonClick={onShareProfile}
                />
              </ProfileSharePopup>
            </>
          )}
          {isMob ? (
            <div className={classNames('social-icons-wrap', { guestSocial: guestUser })}>
              {socialLinks?.data?.map((item: SocialLink) => {
                if (item.link && item.type === 'twitter') {
                  return (
                    <a key={item.link} href={item.link} target="_blank" className="social-icon scc-place twit-icon" rel="noreferrer">
                      <TwitterIcon />
                    </a>
                  );
                }
                if (item.link && item.type === 'linkedin') {
                  return (
                    <a key={item.link} href={item.link} target="_blank" className="social-icon scc-place" rel="noreferrer">
                      <LinkedInIcon />
                    </a>
                  );
                }
                return null;
              })}
            </div>
          ) : null}
        </div>
      </div>
      <div className="d-flex justify-content-between flex-column description-row">
        <p className="text-truncate-three-line">
          {behaviour?.description}
        </p>
        <MoreOnPersonality color={personaColor} className="more-on-personality">
          <DrawerPersonPersonality
            personaColor={personaColor}
            personality={personInfo?.personName}
            disk={archeType && archeType?.image ? archeType?.image : ''}
            isGuestUser={guestUser}
          />
        </MoreOnPersonality>
      </div>
      <Row gutter={14}>
        <Col span={24}>
          <Row gutter={16}>
            <Col span={10} xs={24} sm={24} md={14} lg={10}>
              <div className="qualities-container">
                <Qualities {...qualities} />
              </div>
              <div className="qualities-container">
                <CommunicationTips {...communicationTips} />
              </div>
            </Col>
            {!IsMobile() ? (
              <Col span={14} xs={24} sm={24} md={10} lg={14} className="text-center wheel-main-layer">
                {archeType && archeType?.image
                  && (
                    <div className="wheel-outer-layer">
                      <img src={archeType?.image} alt="personality-disc" className={classNames('img-fluid personality-wheel', { dukeDisk: isDukeBoolean })} />
                    </div>
                  )}
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col span={12} />
      </Row>
    </Wrapper>
  );
};

PersonDetails.defaultProps = defaultProps;
export default PersonDetails;
